"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseInvoiceWireSchema = exports.BaseInvoiceSchema = exports.InvoiceComponentWithInvoiceItemsWireSchema = exports.InvoiceComponentWithInvoiceItemsSchema = void 0;
const zod_1 = require("zod");
const UtilTypes = __importStar(require("./Utils"));
const typeguardUtils_1 = require("../typeguards/typeguardUtils");
// ============================================================================
// ZOD SCHEMAS
// ============================================================================
// Invoice Item Status
const InvoiceItemStatusIterable = ['created', 'paid', 'canceled'];
// Invoice Mismatch Metadata
const InvoiceMismatchMetadataItemSchema = zod_1.z.object({
    inputAmount: zod_1.z.number(),
    inputProRataShare: zod_1.z.number().nullable(),
    finleyAmount: zod_1.z.number(),
    finleyProRataShare: zod_1.z.number().nullable(),
});
// Accounting Account Schema - matches AccountDetailsWithId = PreDB<AccountingAccount> & { id: string }
// AccountingAccount has: id, tAccount, organizationId, creditFacilityId, created_at, updated_at
// PreDB omits: created_at, updated_at, id
// So AccountDetailsWithId = { tAccount, organizationId, creditFacilityId } & { id } = { id, tAccount, organizationId, creditFacilityId }
// Note: Using z.string() for tAccount because TAccountIterable is missing LongTermAssetAccounts
const AccountDetailsWithIdSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tAccount: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    creditFacilityId: zod_1.z.string(),
});
// Wire schema version (for JSON schema generation)
const AccountDetailsWithIdWireSchema = AccountDetailsWithIdSchema;
// Invoice Item - Domain Schema (with Date)
const InvoiceItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    invoiceId: zod_1.z.string(),
    invoiceComponentId: zod_1.z.string(),
    accountingAccountId: zod_1.z.string(),
    amount: zod_1.z.number(),
    status: zod_1.z.enum(InvoiceItemStatusIterable),
    capitalizedLoanId: zod_1.z.string().nullable(),
    finleyAccruedAmount: zod_1.z.number().nullable(),
    created_at: typeguardUtils_1.zodDateTimeSchema,
    updated_at: typeguardUtils_1.zodDateTimeSchema,
});
// Invoice Item - Wire Schema (for JSON schema generation)
const InvoiceItemWireSchema = zod_1.z.object({
    id: zod_1.z.string(),
    invoiceId: zod_1.z.string(),
    invoiceComponentId: zod_1.z.string(),
    accountingAccountId: zod_1.z.string(),
    amount: zod_1.z.number(),
    status: zod_1.z.enum(InvoiceItemStatusIterable),
    capitalizedLoanId: zod_1.z.string().nullable(),
    finleyAccruedAmount: zod_1.z.number().nullable(),
    created_at: typeguardUtils_1.zodDateTimeWireSchema,
    updated_at: typeguardUtils_1.zodDateTimeWireSchema,
});
// Invoice Item with Accounting Account Details
const InvoiceItemWithAccountingAccountDetailsSchema = InvoiceItemSchema.extend({
    accountingAccount: AccountDetailsWithIdSchema,
});
const InvoiceItemWithAccountingAccountDetailsWireSchema = InvoiceItemWireSchema.extend({
    accountingAccount: AccountDetailsWithIdWireSchema,
});
// Invoice Component Type
const InvoiceComponentTypeIterable = ['creditFacility', 'loan'];
// Base Invoice Component - Domain Schema (with Date)
const BaseInvoiceComponentSchema = zod_1.z.object({
    id: zod_1.z.string(),
    invoiceId: zod_1.z.string(),
    finleyLoanId: zod_1.z.string().nullable(),
    invoiceComponentType: zod_1.z.enum(InvoiceComponentTypeIterable),
    totalAmount: zod_1.z.number(),
    metadata: zod_1.z
        .object({
        mismatches: zod_1.z.array(InvoiceMismatchMetadataItemSchema),
    })
        .nullable(),
    accrualStartDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct,
    accrualEndDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct,
    created_at: typeguardUtils_1.zodDateTimeSchema,
    updated_at: typeguardUtils_1.zodDateTimeSchema,
});
// Base Invoice Component - Wire Schema (for JSON schema generation)
const BaseInvoiceComponentWireSchema = zod_1.z.object({
    id: zod_1.z.string(),
    invoiceId: zod_1.z.string(),
    finleyLoanId: zod_1.z.string().nullable(),
    invoiceComponentType: zod_1.z.enum(InvoiceComponentTypeIterable),
    totalAmount: zod_1.z.number(),
    metadata: zod_1.z
        .object({
        mismatches: zod_1.z.array(InvoiceMismatchMetadataItemSchema),
    })
        .nullable(),
    accrualStartDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct,
    accrualEndDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct,
    created_at: typeguardUtils_1.zodDateTimeWireSchema,
    updated_at: typeguardUtils_1.zodDateTimeWireSchema,
});
// Invoice Component with Invoice Items - Domain Schema
exports.InvoiceComponentWithInvoiceItemsSchema = zod_1.z.object({
    invoiceComponent: BaseInvoiceComponentSchema,
    invoiceItems: zod_1.z.array(InvoiceItemWithAccountingAccountDetailsSchema),
});
// Invoice Component with Invoice Items - Wire Schema
exports.InvoiceComponentWithInvoiceItemsWireSchema = zod_1.z.object({
    invoiceComponent: BaseInvoiceComponentWireSchema,
    invoiceItems: zod_1.z.array(InvoiceItemWithAccountingAccountDetailsWireSchema),
});
// Invoice Type and Status
const InvoiceTypeIterable = ['creditFacility', 'loan'];
const InvoiceStatusIterable = ['created', 'paid', 'canceled'];
const InvoiceCreatedByTypeIterable = [
    'user',
    'ibs',
    'onboardingReference',
];
// Base Invoice - Domain Schema (with Date)
exports.BaseInvoiceSchema = zod_1.z.object({
    id: zod_1.z.string(),
    creditFacilityId: zod_1.z.string(),
    finleyLoanId: zod_1.z.string().nullable(),
    originatingInvoiceId: zod_1.z.string().nullable(),
    paymentSourceOrganizationId: zod_1.z.string(),
    paymentDestinationOrganizationId: zod_1.z.string(),
    sourceBankAccountId: zod_1.z.string().nullable(),
    destinationBankAccountId: zod_1.z.string().nullable(),
    invoiceType: zod_1.z.enum(InvoiceTypeIterable),
    status: zod_1.z.enum(InvoiceStatusIterable),
    totalAmount: zod_1.z.number(),
    autoSettle: zod_1.z.boolean(),
    memo: zod_1.z.string().nullable(),
    createdByType: zod_1.z.enum(InvoiceCreatedByTypeIterable),
    accrualStartDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct,
    accrualEndDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct,
    targetInvoiceDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct.nullable(),
    dueDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct,
    paymentDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct.nullable(),
    created_at: typeguardUtils_1.zodDateTimeSchema,
    updated_at: typeguardUtils_1.zodDateTimeSchema,
});
// Base Invoice - Wire Schema (for JSON schema generation)
exports.BaseInvoiceWireSchema = zod_1.z.object({
    id: zod_1.z.string(),
    creditFacilityId: zod_1.z.string(),
    finleyLoanId: zod_1.z.string().nullable(),
    originatingInvoiceId: zod_1.z.string().nullable(),
    paymentSourceOrganizationId: zod_1.z.string(),
    paymentDestinationOrganizationId: zod_1.z.string(),
    sourceBankAccountId: zod_1.z.string().nullable(),
    destinationBankAccountId: zod_1.z.string().nullable(),
    invoiceType: zod_1.z.enum(InvoiceTypeIterable),
    status: zod_1.z.enum(InvoiceStatusIterable),
    totalAmount: zod_1.z.number(),
    autoSettle: zod_1.z.boolean(),
    memo: zod_1.z.string().nullable(),
    createdByType: zod_1.z.enum(InvoiceCreatedByTypeIterable),
    accrualStartDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct,
    accrualEndDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct,
    targetInvoiceDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct.nullable(),
    dueDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct,
    paymentDate: UtilTypes.ZodFullDateStrForJsonSchemaStruct.nullable(),
    created_at: typeguardUtils_1.zodDateTimeWireSchema,
    updated_at: typeguardUtils_1.zodDateTimeWireSchema,
});
//# sourceMappingURL=Invoice.js.map